<template>
    <div style="position: relative;" id="divcropper1">
        <h6 class="title-cropper">{{ title }}</h6>
        <div v-if="!srcImage" class="div-father-btn-toggle-camera">
            <div class="div-btn-toggle-camera">
                <i class="material-icons icon-button-cropper" @click.prevent="toggleOptions()">camera_alt</i>
            </div>
            <div v-if="toggle" class="mf__div-btn-flex-space-between" style="margin-top: 20px;">
                <button class="custom-btn-upload" @click.prevent="takePicture">Foto</button>
                <label :for="`file-upload-${title}`" class="custom-btn-upload">Upload de Imagem</label>
                <input style="display: none;" @change="setImage" :id="`file-upload-${title}`" type="file"
                    accept="image/*">
            </div>
        </div>
        <div class="img-document" id="divcropper2">
            <div id="divcropper3">
                <div v-if="imageData" id="divcropper4">
                    <Cropper id="cropper1" ref="cropper" :src="imageData" :stencil-props="{ aspectRatio: null }"
                        :background="false" />
                </div>
                <div v-if="!croppedImage && imageData" class="mf__div-btn-flex-space-between" style="margin-top: 20px;">
                    <button @click.prevent="cancelImage" class="custom-btn-upload">Cancelar</button>
                    <button @click.prevent="cropAndUploadImage" class="custom-btn-upload">Ok</button>
                </div>
                <div v-if="imageUrl" class="uploadedImage" id="divcropper6">
                    <img :src="imageUrl">
                    <button class="custom-btn-upload" @click.prevent="cancelImage">Escolher outra imagem</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FirebaseHelper from '@/service/FirebaseHelper';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
    components: {
        Cropper,
    },
    props: {
        title: {
            type: String,
        },
        filename: {
            type: String,
            required: true,
        },
        redondlyMode: {
            type: Boolean,
            default: false,
        },
        picture: {
            type: String,
        },
    },
    data() {
        return {
            srcImage: null,
            firebaseHelper: new FirebaseHelper(),
            imageData: false,
            croppedImage: false,
            toggle: false,
            loading: false,
            imageUrl: false
        };
    },
    computed: {
        ...mapGetters({
            chave: 'chave',
        }),
    },
    methods: {
        toggleOptions() {
            this.toggle = !this.toggle;
            this.srcImage = this.picture
        },
        takePicture() {
            this.imageData = null;
            this.croppedImage = null;

            if (!navigator.camera) {
                console.log('Camera plugin não está disponível.');
                alert('Camera plugin não está disponível.');
                return;
            }
            navigator.camera.getPicture(
                (imageData) => {
                    this.imageData = 'data:image/jpeg;base64,' + imageData;
                },
                (message) => {
                    alert('Falha ao tirar foto: ' + message);
                },
                {
                    quality: 50, // Ajuste conforme necessário
                    destinationType: Camera.DestinationType.DATA_URL,
                    targetWidth: 1920, // Reduza a resolução para ajudar a controlar o tamanho
                    targetHeight: 1080, // Mantenha a proporção ao ajustar
                    encodingType: Camera.EncodingType.JPEG,
                    correctOrientation: true,
                }
            );
        },
        cropAndUploadImage() {
            const { canvas } = this.$refs.cropper.getResult();
            if (!canvas) {
                console.error('Canvas não gerado. Verifique o Cropper.');
                return;
            }

            this.loading = true;
            const compressAndUpload = (quality) => {
                console.log(`Tentando upload com qualidade ${quality}`);
                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error('Falha ao converter canvas para blob.');
                        this.loading = false;
                        return;
                    }

                    console.log(`Tamanho do blob: ${(blob.size / (1024 * 1024)).toFixed(2)} MB`);
                    if (blob.size > 3 * 1024 * 1024) {
                        // Se o tamanho ainda for maior que 3MB, tente diminuir a qualidade
                        if (quality > 0.1) {
                            console.log('Imagem muito grande, diminuindo a qualidade para', quality - 0.1);
                            compressAndUpload(quality - 0.1);
                        } else {
                            console.error('Não foi possível reduzir a imagem abaixo de 3MB');
                            this.loading = false;
                        }
                    } else {
                        this.uploadImage(blob);
                    }
                }, 'image/jpeg', quality);
            };

            compressAndUpload(0.8); // Comece com qualidade 80%
        },
        uploadImage(image) {
            console.log('Iniciando upload da imagem...');
            this.firebaseHelper.uploadImage(this.chave, image, this.filename).then((url) => {
                console.log('Upload bem-sucedido, URL:', url);
                this.imageUrl = url;
                this.loading = false;
                this.imageData = false;
                this.croppedImage = false;
                this.$emit('upload-foto', url);
            }).catch(error => {
                console.error('Erro no upload:', error);
                this.loading = false;
            });
        },
        setImage(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imageData = e.target.result;
                    this.srcImage = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        cancelImage() {
            this.imageData = false;
            this.croppedImage = false;
            this.toggle = false;
            this.imageUrl = false;
            this.srcImage = null
        }
    },
};
</script>


<style scoped>
.btns-upload-files {
    display: flex;
    justify-content: space-between;
    transition: ease-in 0.8s;
}

.btns-upload-files button,
.custom-btn-upload {
    width: 48%;
    border-radius: 12px !important;
}

.custom-btn-upload {
    height: 40px;
    padding: 5px 10px;
    /* margin: 20px 0; */
    min-width: initial;
    /* width: 44%; */
    border: none;
    border-radius: 8px !important;
    background: #0c7bc6;
    font-size: 14px;
    color: white;
    cursor: pointer;
    transition: transform 0.2s cubic-bezier(0.64, 0.09, 0.08, 1), box-shadow 0.2s cubic-bezier(0.64, 0.09, 0.08, 1);
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.custom-btn-upload:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.2);
}

.img-document {
    display: flex;
    flex-direction: column;
    max-width: 300px;
    height: auto;
    margin: 0 auto;
    padding: 10px;
    position: relative;
}

.img-document img {
    max-width: 90%;
    /* max-height: 200px; */
    margin: auto;
}

@media screen and (min-width: 425px) {
    .img-document {
        max-width: 340px;
    }
}

@media screen and (min-width: 525px) {
    .img-document {
        max-width: 440px;
    }
}

@media screen and (min-width: 625px) {
    .img-document {
        max-width: 540px;
    }
}

.uploadedImage {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.uploadedImage button {
    width: 70%;
    margin: 10px auto;
    padding: 8px;
    height: auto;
}

.left-btn {
    float: left;
    background-color: #C4C4C4;
}

.right-btn {
    float: right;
}

.div-father-btn-toggle-camera {
    margin: auto 0;
}

.div-btn-toggle-camera {
    position: absolute;
    top: 0;
    right: 0;
}

h6.title-cropper {
    height: 31px;
    display: flex;
    align-items: center;
}

.div-btn-toggle-camera button {
    width: 40px;
    height: 40px;
    margin: 0;
    outline: none;
}

.icon-button-cropper {
    border-radius: 20px;
    background-color: #03a9f4;
    color: #ffff;
    font-size: 24px !important;
    padding: 5px !important;
    cursor: pointer;
}

.vue-advanced-cropper__cropper-wrapper {
    width: 85% !important;
    height: 85% !important;
}

.vue-advanced-cropper__stretcher {
    max-width: 85% !important;
    margin: auto;
}

.vue-advanced-cropper__background {
    max-width: 85% !important;
    margin: auto;
}

.vue-advanced-cropper__foreground {
    max-width: 85% !important;
    margin: auto;
}

body {
    font-family: sans-serif;
    margin: 0;
}

/* css foto windows */
.area {
    margin: 10px auto;
    box-shadow: 0 10px 100px #ccc;
    /* padding: 20px; */
    box-sizing: border-box;
    max-width: 90%;
}

.area video {
    width: 100%;
    height: auto;
    background-color: whitesmoke;
}

.area textarea {
    width: 100%;
    margin-top: 10px;
    height: 80px;
    box-sizing: border-box;
}

.area button {
    min-width: -webkit-fill-available;
    -webkit-appearance: none;
    box-sizing: border-box;
    text-align: center;
    text-transform: uppercase;
}

.area button:focus {
    outline: none;
}
</style>